import React, { useState, useRef } from "react";
import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";
import CustomTable from "../../common/CustomTable/CustomTable";
import moment from "moment";
import queryString from "query-string";
import SystemService from "../../../services/SystemService";
import _ from "lodash";
import { navigate } from "@reach/router";
import ProfileModal from "../../pages/ProfileDetails/components/ProfileModal";
import labels from "../../../helpers/labels.json";
import { parseTimeStamp } from "../../../helpers/functions";

async function getProfiles(query = "") {
  try {
    const response = await SystemService.getProfiles(query);
    return { ...response };
  } catch (error) {
    return error;
  }
}

const MediatorListing = () => {
  const [state, setState] = useState({});
  const placeholderText = labels.search_neutral;
  const MTRef = useRef();
  const [modal, setModal] = useState();
  const [user, setUser] = useState();

  const columns = [
    {
      field: "id",
      title: labels.id_type,
      tooltip: "Unique Identifier for the Arbitrator across IIAC platform",
      render: (rowData) => (
        <HyperLink
          onClick={() => navigate("/dashboard/arbitrator/" + rowData.id)}
        >
          {rowData.id}
        </HyperLink>
      ),
    },
    {
      field: "name",
      title: labels.profile_name,
      render: (rowData) => (
        <Bold onClick={() => navigate("/dashboard/arbitrator/" + rowData.id)}>
          {rowData.name}
        </Bold>
      ),
      sorting: false,
    },
    {
      field: "email",
      tooltip: "Email associated with the Arbitrator",
      title: labels.profile_email,
      sorting: false,
      headerStyle: {
        maxWidth: "120px !important",
        width: "120px !important",
      },
      cellStyle: {
        maxWidth: "120px !important",
        width: "120px !important",
      },
    },

    {
      field: "created_at",
      title: labels.created_on,
      tooltip: "Arbitrator Created Date",
      render: (rowData) => (
        <>{moment(parseTimeStamp(rowData.created_at)).format("DD/MM/YYYY")}</>
      ),
      headerStyle: {
        maxWidth: "120px !important",
        width: "120px !important",
      },
      cellStyle: {
        maxWidth: "120px !important",
        width: "120px !important",
      },
    },
    {
      field: "action",
      title: labels.actions.substring(0, labels.actions.length - 1),
      sorting: false,
      render: (rowData) => (
        <HyperLink
          onClick={() => {
            setUser(rowData);
            setModal(true);
          }}
        >
          {labels.edit_mediator}
        </HyperLink>
      ),
      tooltip: "Option to edit Arbitrator profile",
      headerStyle: {
        maxWidth: "120px !important",
        width: "120px !important",
      },
      cellStyle: {
        maxWidth: "120px !important",
        width: "120px !important",
      },
    },
  ];

  const data = (query) =>
    new Promise((resolve, reject) => {
      let params = {
        page: query.page + 1,
        perPage: 10,
      };
      if (query.search) {
        params.query = query.search;
      }
      params.role = "mediator";
      if (query.orderBy?.field) {
        params.sort = query.orderBy.field;
        params.sortDirection = query.orderDirection;
      }
      let stringParams = "";
      if (!_.isEmpty(params)) {
        stringParams = `?${queryString.stringify(params)}`;
      }
      getProfiles(stringParams)
        .then(async (result) => {
          if (result) {
            resolve({
              data: result.data,
              page: result.page - 1,
              total: result.total,
            });
            setState(result);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  return (
    <div className="myProfiles">
      <Padding>
        <CustomTable
          hideFilterBar
          hidePagination={state.lastPage === 1}
          pageSize={state?.data?.length ? state?.data?.length : 10}
          pluralTitle={_.startCase(labels.mediator)}
          singularTitle=""
          onFilterClick={() => setModal(true)}
          {...{
            columns,
            data,
            placeholderText,
            MTRef,
          }}
          // noToolbar
          // hideFilterBar
          state={state}
        />
        <ProfileModal
          setUser={() => {
            setUser({});
            MTRef.current.onQueryChange();
          }}
          {...{ modal, setModal, user }}
        />
      </Padding>
    </div>
  );
};

export default MediatorListing;

const Padding = styled.div`
  // padding-top: 30px;
  padding-bottom: 50px;
`;
const HyperLink = styled.span`
  cursor: pointer;
  color: ${COLORS.BTN_GREEN};
  text-decoration: underline;
  padding-left: 29px;
`;
const Bold = styled.span`
  cursor: pointer;
  font-family: ${theme.fonts.primaryFontSemiBold};
`;
